import React, { useEffect } from "react";
import { ImageLayout } from "../../elements/image";
import { StyledBox, StyledContainer, StyledGrid, StyledTypography } from "@hcl-commerce-store-sdk/react-component";
import { Box, Typography, useMediaQuery, useTheme, Stack } from "@mui/material";
import { StyledButton } from "../../../styled-mui";
import podcastBanner from "../../../podCastImage/poadCastBanner.jpg";
import podcastBannerMobile from "../../../podCastImage/podcastImageMobile.png";
import podcastDoorImage from "../../../podCastImage/door-story.png";
import podcastDoorImageMobile from "../../../podCastImage/podcastDoorImageMobile.png";
import podcastLeftImg from "../../../podCastImage/Container.png";
import podcastLeftImgMobile from "../../../podCastImage/visuels.png";
import podcastRightImg from "../../../podCastImage/magic-clips.png";
import podcastRightImgMobile from "../../../podCastImage/ContainerMobile.png";
import AsyncCall from "../../../_foundation/gtm/async.service";
import { CLICK } from "../../../_foundation/constants/gtm";
import UADataService from "../../../_foundation/gtm/data.service";
import { useSite } from "../../../_foundation/hooks/useSite";
import { StyledHeroBanner2Columns } from "../../elements/inspiration/hero-banner-2-columns/styled-heroBanner2Columns";
import DoorStoryBanner from "../../elements/podCastPage/podCastHero";
import { Helmet } from "react-helmet";
import { SeoHead } from "../../elements/seo-head/SeoHead";

const PodcastIframe = ({ isMobile }) => {
  return (
    <iframe
      src="https://embed.acast.com/69e88f8a289eeb2c7b6bfcc2/69e890716eeb59e2bac8ad41"
      frameBorder="0"
      width="100%"
      height={"190px"}
      title="Lapeyre Podcast Player"
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
    />
  );
};

const PodcastLandingPage: React.FC = () => {
  const handleAllEpisodesClick = () => {
    AsyncCall.sendClick(CLICK.CTA, {
      btn_label: "Ecouter tous les épisodes",
      page_type: "page_podcast",
      content_group: "contenu",
      click_destination: "https://feeds.acast.com/public/shows/69e88f8a289eeb2c7b6bfcc2",
    });
    window.open("https://feeds.acast.com/public/shows/69e88f8a289eeb2c7b6bfcc2", "_blank", "noopener");
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { mySite } = useSite();

  const seo = {
    title: "Door Story, le podcast | Lapeyre",
    description: "Découvrez Door Story, la série podcast de Lapeyre qui raconte des moments de vie !",
  };

  useEffect(() => {
    const breadcrumbs = [{ label: "lapeyre-podcast-door-story", value: "1" }];
    if (mySite.enableGA) {
      if (mySite.enableUA) {
        UADataService.setPageData("page_podcast", "contenu");
      }
      AsyncCall.sendContentPageViewEvent({ breadcrumbs });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SeoHead seo={seo} defaultTitle={"Door Story, le podcast | Lapeyre"} />
      <DoorStoryBanner />

      <Box
        sx={{
          background: "#222B3F",
          padding: { xs: "0", md: "35px 0" },
          borderRadius: { xs: "10px", md: "0" },
          margin: { xs: "12px 8px", md: 0 },
        }}>
        <StyledContainer>
          <PodcastIframe isMobile={isMobile} />
        </StyledContainer>
      </Box>
      <StyledContainer>
        <Box sx={{ py: { xs: "45px", md: "100px" }, textAlign: "center", px: { xs: 4, md: 0 } }}>
          <Box>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                fontSize: isMobile ? "32px" : "32px",
                lineHeight: isMobile ? "36px" : "32px",
                letterSpacing: "0%",
                textAlign: "center",
                color: "#262626",
                mb: "20px",
              }}>
              Plongez dans la série{" "}
              <span style={{ color: "#5D89A2", textTransform: "uppercase" }}>Door {isMobile ? <br /> : " "}Story</span>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: isMobile ? "16px" : "20px",
                lineHeight: "32px",
                letterSpacing: 0,
                color: "#262626",
                mb: "20px",
              }}>
              Retrouvez la série sur toutes les grandes plateformes d'écoute. <br /> Abonnez-vous pour ne rater aucun
              épisode et recevoir une notification dès la sortie des nouvelles saisons !
            </Typography>
          </Box>
          <Box sx={{ maxWidth: "747px", mx: "auto", mb: "20px", textAlign: "center" }}>
            <ImageLayout
              src={isMobile ? podcastDoorImageMobile : podcastDoorImage}
              alt="Podcast Door Story"
              width="100%"
            />
          </Box>
          <StyledButton
            onClick={handleAllEpisodesClick}
            variant="contained"
            color="secondary"
            type="submit"
            sx={{ width: { xs: "100%", sm: "auto" } }}>
            écouter tous les épisodes
          </StyledButton>
        </Box>
      </StyledContainer>

      <Box
        sx={{
          bgcolor: "#EFF3F6",
          py: { xs: "56px", md: "100px" },
          display: "flex",
          justifyContent: "center",
        }}>
        <StyledContainer>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: { xs: 6, md: "100px" },
              alignItems: "center",
            }}>
            {isMobile && (
              <Box sx={{ borderRadius: "20px", overflow: "hidden" }}>
                <ImageLayout src={podcastLeftImgMobile} alt="Podcast Door Story" width="100%" height="29" />
              </Box>
            )}

            {/* Left: Text */}
            <Box sx={{ px: { xs: 2, md: 0 } }}>
              <Stack sx={{ mb: 6 }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    fontSize: "32px",
                    lineHeight: "36px",
                    letterSpacing: 0,
                    color: "#262626",
                    whiteSpace: "pre-line",
                  }}>
                  {"La série podcast\n de Lapeyre qui raconte\n"}
                  <span
                    style={{
                      fontWeight: 700,
                      fontStyle: "italic",
                      fontSize: "32px",
                      lineHeight: "36px",
                      letterSpacing: 0,
                      color: "#5D89A2",
                    }}>
                    des histoires de vie
                  </span>
                </Typography>
              </Stack>

              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "28px",
                  letterSpacing: 0,
                  color: "#262626",
                }}>
                Chez Lapeyre, nous concevons des produits qui accompagnent les Français depuis des générations. Une
                porte qui se ferme. Une fenêtre entrouverte. Ces détails du quotidien, souvent invisibles, jouent
                pourtant un rôle important dans les moments de vie.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "28px",
                  letterSpacing: 0,
                  color: "#262626",
                  mt: 4,
                }}>
                Avec DOOR STORY, nous explorons un nouveau territoire d'expression : la fiction audio. Une œuvre en
                trois saisons, où les personnages et les émotions sont au cœur du récit. Ici, nos produits ne sont pas
                mis en avant. Ils sont là, simplement, en arrière-plan des histoires, comme dans la vraie vie.
              </Typography>
            </Box>

            {/* Right: Image */}
            {!isMobile && (
              <Box sx={{ borderRadius: "20px", overflow: "hidden" }}>
                <ImageLayout src={podcastLeftImg} alt="Podcast Door Story" width="100%" height="29" />
              </Box>
            )}
          </Box>
        </StyledContainer>
      </Box>

      <Box
        sx={{
          py: { xs: "56px", md: "100px" },
          display: "flex",
          justifyContent: "center",
        }}>
        <StyledContainer>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: { xs: 4, md: "100px" },
              alignItems: "center",
            }}>
            {/* Left: Image */}
            <Box sx={{ borderRadius: "20px", overflow: "hidden" }}>
              <ImageLayout
                src={isMobile ? podcastRightImgMobile : podcastRightImg}
                alt="Podcast Door Story"
                width="100%"
              />
            </Box>

            {/* Right: Text */}
            <Box sx={{ px: { xs: 2, md: 0 } }}>
              <Stack sx={{ mb: 6 }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    fontSize: "32px",
                    lineHeight: "36px",
                    letterSpacing: 0,
                    color: "#262626",
                    whiteSpace: "pre-line",
                  }}>
                  {"Une fiction audio originale\n"}
                  <span
                    style={{
                      fontWeight: 700,
                      fontStyle: "italic",
                      fontSize: "32px",
                      lineHeight: "36px",
                      letterSpacing: 0,
                      color: "#5D89A2",
                    }}>
                    des histoires de vie
                  </span>
                </Typography>
              </Stack>

              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "28px",
                  letterSpacing: 0,
                  color: "#262626",
                }}>
                Door Story a été conçue dès l’origine comme une véritable fiction audio. Écrite par des auteurs de
                fiction et interprétée par des comédiens professionnels, la série adopte les codes d’une production
                exigeante. Le travail sonore et musical y occupe une place essentielle, renforçant l’immersion à chaque
                épisode. Découvrez la série et profitez d’une expérience d’écoute sensible et engageante.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  textTransform: "italic",
                  lineHeight: "28px",
                  letterSpacing: 0,
                  color: "#5D89A2",
                  mt: 4,
                }}>
                « Avec Door Story, nous ne sommes plus seulement présents dans les maisons, mais dans les histoires de
                vie, avec humour et décalage. »
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "28px",
                  letterSpacing: 0,
                  color: "#262626",
                  mt: 0,
                  pr: { xs: 0, md: 4 },
                  textAlign: "right",
                }}>
                Fanny Mafalanka, {isMobile ? <br /> : " "}Responsable Acquisition
              </Typography>
            </Box>
          </Box>
        </StyledContainer>
      </Box>
    </>
  );
};

export default PodcastLandingPage;
